import * as actionTypes from './types';

export const setIsVGSCollectScriptLoading = () => ({
    type: actionTypes.SET_IS_VGS_COLLECT_SCRIPT_LOADING,
});

export const setIsVGSCollectScriptSuccess = (data) => ({
    type: actionTypes.SET_IS_VGS_COLLECT_SCRIPT_SUCCESS,
    data,
});

export const setIsVGSCollectScriptError = () => ({
    type: actionTypes.SET_IS_VGS_COLLECT_SCRIPT_ERROR,
});

export const setIsVGSShowScriptLoading = () => ({
    type: actionTypes.SET_IS_VGS_SHOW_SCRIPT_LOADING,
});

export const setIsVGSShowScriptSuccess = (data) => ({
    type: actionTypes.SET_IS_VGS_SHOW_SCRIPT_SUCCESS,
    data,
});

export const setIsVGSShowScriptError = () => ({
    type: actionTypes.SET_IS_VGS_SHOW_SCRIPT_ERROR,
});

export const setIsBankInfoSubmissionFormCreated = (data) => ({
    type: actionTypes.SET_IS_BANK_INFO_SUBMISSION_FORM_CREATED,
    data,
});
